<template>
  <div>
    <BaseOverlay/>
    <router-view></router-view>
  </div>
</template>

<script>
import {defineAsyncComponent} from 'vue';
import {ARBS_PAGE_MOBILE_FRINGE_RES} from '../const';

window.hide_hints = function() {
  window.vm.hints.openModal();
};

// У floating-vue шаблон тултипа фиксированный — глобальной иконки закрытия хинтов нет;
// disposeTimeout задается в entrypoints/main.js.
import {mapMutations} from 'vuex';

export default {
  name: 'TheMainLayout',
  data() {
    return {
      isMobileView: false,
    };
  },
  methods: {
    ...mapMutations({
      commitToggleHints: 'TOGGLE_HINTS',
    }),
    onResize() {
      this.isMobileView = window.innerWidth <= ARBS_PAGE_MOBILE_FRINGE_RES;
    },
    openModal() {
      this.$bus.$emit('show-modal', {
        component: defineAsyncComponent(() => import('./scanner-common/modals/CheckHideHintsModal.vue')),
      });
    },
  },
  created() {
    this.isMobileView = window.innerWidth <= ARBS_PAGE_MOBILE_FRINGE_RES;
    if (window.current_user && window.current_user.settings !== undefined) {
      if (JSON.parse(window.current_user.settings).profile &&
          JSON.parse(window.current_user.settings).profile.show_hints !== undefined &&
          JSON.parse(window.current_user.settings).profile.show_hints === 0) {
        this.commitToggleHints(false);
      }
    }
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener('resize', this.onResize);
    });
    window.vm.hints = this; // корневой инстанс объявляет hints в data (см. entrypoints/main.js)
  },
};
</script>

<style lang="scss">
// Глобальная тема тултипов и дропдаунов floating-vue (разметка .v-popper__*)
.v-popper__popper.v-popper--theme-tooltip {
  z-index: 10000000;

  .v-popper__inner {
    background: rgba(0, 0, 0, 0.72);
    color: white;
    border-radius: 5px;
    padding: 5px 20px;
    font-size: 12px;

    &:hover {
      background: rgba(0, 0, 0, 1);
    }
  }

  .v-popper__arrow-outer {
    border-color: rgba(0, 0, 0, 0.72);
  }
}

.v-popper__popper.v-popper--theme-dropdown {
  $color: #f9f9f9;

  .v-popper__inner {
    background: $color;
    color: black;
    padding: 24px;
    border: none;
    border-radius: 5px;
    box-shadow: 0 5px 30px rgba(black, .1);
  }

  .v-popper__arrow-inner,
  .v-popper__arrow-outer {
    border-color: $color;
  }
}
</style>
